import useSWRMutation from 'swr/mutation'
import { Form, Modal } from 'antd'
import { postFetcher } from '@BUP/services/Axios'
import { ComplaintEntryFormInputs } from './form-inputs.jsx'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export function ComplaintEntryFormModal ({ complaintId, onOk, onCancel, ...props }) {
  const i18n = useTranslation()
  const { trigger, isMutating } = useSWRMutation(`/current-enrollment/complaints/${complaintId}/complaint-entries`, postFetcher)
  const [form] = Form.useForm()
  const navigate = useNavigate()

  const handleSubmit = async values => {
    try {
      const complaintEntry = await trigger(values)
      if (complaintEntry) {
        form.resetFields()
        onOk(complaintEntry)
        navigate(`/logbook/complaints/${complaintEntry.complaintId}/entries/${complaintEntry.id}`)
      }
    } catch (error) {
      console.debug('ComplaintEntryFormModal', 'handleSubmit', 'catch', error)
    }
  }

  const handleOk = () => form.submit()

  const handleCancel = () => {
    form.resetFields()
    onCancel()
  }

  return (
    <Modal
      title={i18n.t('common.resources.complaint-entry.actions.create.submit')}
      confirmLoading={isMutating}
      {...props}
      onCancel={handleCancel}
      onOk={handleOk}
    >
      <Form form={form} onFinish={handleSubmit} layout='vertical'>
        <ComplaintEntryFormInputs />
      </Form>
    </Modal>
  )
}
